<template>
  <div class="pro-outer">
    <div class="left">
      <div class="title">{{ title }}</div>
      <div class="click">
        <a-button class="but" type="dashed"
          ><a-icon type="plus" />{{ name }}
          <input
            :accept="accept"
            class="input-upload"
            type="file"
            @change="uploadFile"
            :disabled="isDisabled"
        /></a-button>
      </div>
      <div class="tips">{{ tips }}</div>
    </div>

    <div class="pro-inner" v-for="(fileInfo, index) in fileList" :key="index">
      <div class="upload-top">
        <!-- 是否存在文件 -->
        <div class="name" v-if="fileInfo.fileName">
          <img :src="getIcon(fileInfo.fileType)" />
          <span>{{ fileInfo.fileName }}</span>
        </div>
      </div>

      <div class="upload-middle">
        <div class="progress" v-if="fileInfo.uploadStep == '1'">
          <a-progress :percent="fileInfo.progressValue" status="active" />
        </div>
        <!-- <div v-else-if="fileInfo.uploadStep == '2'">上传失败</div>
        <div v-else-if="fileInfo.uploadStep == '3'">上传成功</div> -->
      </div>

      <div class="upload-bottom">
        <!-- 正在上传 -->
        <div class="close" v-if="fileInfo.uploadStep == '1'">
          <a-button
            @click="cancelUpload(fileInfo.client, index)"
            shape="circle"
            icon="close"
            size="small"
          ></a-button>
        </div>
        <div class="oper" v-else-if="fileInfo.fileName">
          <div class="reset hover-font-active">
            <span v-if="!isDisabled">替换</span>
            <input
              :accept="accept"
              class="input-upload"
              type="file"
              @change="uploadFile($event, index)"
              :disabled="isDisabled"
            />
          </div>
          <span
            v-if="!isDisabled"
            class="delete hover-font-active"
            @click="deleteFile(index)"
            >删除</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ossApi from '../../api/oss'

import OSS from 'ali-oss'

export default {
  name: 'CProgress',
  data() {
    return {
      client: null, //oss对象
      fileList: [], //文件对象
      fileAccept: '', //文件类型
    }
  },
  props: [
    'name',
    'icon',
    'sourceFileList',
    'id',
    'videoObj',
    'backIndex',
    'isDisabled',
    'title',
    'lesType',
    'tips',
    'accept',
  ],
  watch: {
    videoObj: {
      handler: function () {
        this.init()
      },
      deep: true,
    },
  },
  methods: {
    getIcon(icon) {
      // console.log('icon---------', icon)
      return utils.common.getIcon(icon)
    },

    //取消上传
    cancelUpload(client, index) {
      let self = this
      this.$confirm({
        title: '确定要删除吗?',
        okText: '确定',
        cancelText: '取消',
        content: '删除后，无法撤销',
        onOk() {
          client.cancel()
          self.fileList.splice(index, 1)
        },
      })
    },

    //删除文件
    deleteFile(index) {
      //清空
      this.fileList.splice(index, 1)
      //回调
      this.$emit('uploadSuccess', this.backIndex)
    },

    //清空
    clearFile() {
      this.fileInfo = {}
    },

    getFileUrl(fileType, icon, fileName) {
      console.log('icon----------------', icon)
      if (this.icon == 'attachment') {
        return `course/resource/attachment/${utils.common.getUuid()}_${fileName}.${fileType}`
      }
      if (icon.indexOf('video') != -1) {
        return `course/resource/video/${utils.common.getUuid()}_${fileName}.${fileType}`
      } else if (icon.indexOf('audio') != -1) {
        return `course/resource/audio/${utils.common.getUuid()}_${fileName}.${fileType}`
      } else if (icon.indexOf('zip') != -1) {
        return `course/resource/zips/ware-${utils.common.getUuid()}_${fileName}.${fileType}`
      } else if (icon.indexOf('pdf') != -1) {
        return `course/resource/pdf/ware-${utils.common.getUuid()}_${fileName}.${fileType}`
      } else if (icon.indexOf('image') != -1) {
        return `course/resource/image/ware-${utils.common.getUuid()}_${fileName}.${fileType}`
      } else {
        this.$message.warn('请上传图片/PDF格式/zip文件')
        return ''
      }
    },

    async getACL(client, key) {
      let result = await client.getACL(key)

      await client.putACL(key, 'private')
    },

    uploadFile(e, index) {
      console.log('e', e)
      this.$emit('buttonDisabled', true)
      if (e.target.files.length == 0) {
        return
      }
      let self = this
      //如果index存在，定向修改，反之就是新增
      if (!index && index != 0) {
        console.log('111')
        this.fileList.push({})
        index = this.fileList.length - 1
      }
      // this.clearFile()
      //清空文件
      this.$set(this.fileList, index, {})
      //开始上传
      this.$set(this.fileList[index], 'uploadStep', '1')

      this.getStsToken()
        .then((res) => {
          let file = e.target.files[0]
          this.$set(this.fileList[index], 'fileName', file.name)
          this.$set(this.fileList[index], 'fileSize', file.size)
          this.$set(this.fileList[index], 'fileType', file.type)
          let fileName = file && file.name ? file.name.split('.') : ['jpg']
          let storeAs = this.getFileUrl(
            fileName[fileName.length - 1],
            file.type,
            fileName[fileName.length - 2]
          )

          this.fileList[index].client = new OSS({
            accessKeyId: res.accessKeyId,
            accessKeySecret: res.accessKeySecret,
            stsToken: res.securityToken,
            bucket: 'after-class',
            region: 'oss-cn-hangzhou',
          })
          //storeAs表示上传的object name , file表示上传的文件
          this.fileList[index].client
            .multipartUpload(
              storeAs,
              file,
              //可扩展为断点上传断点上传 文档：https://help.aliyun.com/document_detail/64047.html?spm=a2c4g.11186623.4.2.1a9b79f8OCWyHn
              {
                progress: async function (p, checkpoint) {
                  //文件上传进度获取
                  self.$set(
                    self.fileList[index],
                    'progressValue',
                    parseInt(p * 100)
                  )
                },
              }
            )
            .then(function (result) {
              self.getACL(self.fileList[index].client, result.name)
              let url = window.globalConfig.fileUrl + result.name
              self.successUpload(file, url, index)
              // this.$emit('buttonDisabled', false)
              // console.log('this.disabled', this.disabled)
            })
            .catch((e) => {
              self.uploadError(e, index)
              // this.disabled = false
              // this.$emit('buttonDisabled', false)
              // console.log('this.disabled', this.disabled)
            })
            .finally(() => {
              this.$emit('buttonDisabled', false)
            })
            .finally(() => {
              this.$emit('buttonDisabled', false)
            })
            .finally(() => {
              this.$emit('buttonDisabled', false)
            })
          e.target.value = ''
        })
        .catch((e) => {
          self.uploadError(e, index)
        })
    },

    //文件上传失败提示
    uploadError(e, index) {
      console.log('上传失败-----', e, index)
      this.$message.error('上传失败')
      this.fileList[index].uploadStep = '2'
    },

    //文件上传成功处理
    successUpload(file, url, index) {
      this.$message.success('上传成功')
      this.fileList[index].uploadStep = '3'
      this.fileList[index].fileUrl = url

      this.$emit('uploadSuccess', this.backIndex)
    },

    successUpload_data() {
      //给后台需要的数据
      let tempList = []
      this.fileList.map((item) => {
        //失败不push
        if (item.uploadStep != '2') {
          let temObj = {
            fileUrl: item.fileUrl,
            fileName: item.fileName,
            fileSize: item.fileSize,
            fileType: item.fileType,
            lesType: this.lesType,
          }
          tempList.push(temObj)
        }
      })
      return tempList
    },

    //获取OSS token
    getStsToken() {
      let tempStsToken = this.$ls.get('stsToken')

      let promise = new Promise((resolve, reject) => {
        if (tempStsToken) {
          let tempDate = new Date(tempStsToken.expiration)
          let tempNowDate = new Date()

          if (tempNowDate.getTime() > tempDate.getTime()) {
            ossApi.getOssStsToken().then((res) => {
              if (res.code == 0) {
                //把stsToken放入对应的缓存里
                this.$ls.set('stsToken', res.stsToken)
                resolve(res.stsToken)
              } else {
                reject(res)
              }
            })
          } else {
            resolve(tempStsToken)
          }
        } else {
          ossApi.getOssStsToken().then((res) => {
            if (res.code == 0) {
              //把stsToken放入对应的缓存里
              this.$ls.set('stsToken', res.stsToken)
              resolve(res.stsToken)
            } else {
              reject(res)
            }
          })
        }
      })
      return promise
    },

    //初始化
    init() {
      this.fileList = this.videoObj
        ? this.videoObj.filter((item) => item.lesType == this.lesType)
        : []
    },
  },
  created() {
    this.init()
  },
}
</script>
<style lang="scss" scoped>
.pro-outer {
  text-align: left;
  margin-bottom: 10px;
  > .title {
    text-align: left;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    vertical-align: middle;
    display: inline-block;
    margin-right: 20px;
  }
}
.pro-inner {
  display: flex;
  font-size: 14px;
  line-height: 40px;
}
.left {
  display: flex;
}
.click {
  width: 110px;
  text-align: left;
  display: inline-block;
  vertical-align: middle;
  overflow: hidden;
  position: relative;
  margin-left: 10px;
}
.tips {
  font-size: 12px;
  margin-left: 10px;
}
.upload-top {
  flex: none;
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  .name {
    display: inline-block;
    img {
      vertical-align: middle;
      width: 20px;
    }
    span {
      vertical-align: middle;
      display: inline-block;
      margin-left: 10px;
    }
  }
}

.input-upload {
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  z-index: 999;
  cursor: pointer;
  opacity: 0;
}

.upload-middle {
  flex: none;
  width: 160px;
  margin-left: 10px;
}
.upload-bottom {
  flex: 1;
  vertical-align: middle;
  margin-left: 20px;
  text-align: right;
  .close {
  }
  .oper {
    .reset {
      color: #5c74ff;
      margin-right: 10px;
      display: inline-block;
      position: relative;
      overflow: hidden;
      vertical-align: middle;
    }
    .delete {
      color: #f54d15;
      display: inline-block;
      vertical-align: middle;
    }
  }
}
</style>
